<template>
  <ValidationObserver
    ref="observer"
    v-slot="{ valid }"
  >
    <form>
      <v-row>
        <v-col>
          <VPassword
            v-model="user.oldPassword"
            :label="$t('forms.labels.oldPassword')"
            :value="user.oldPassword"
            data-cy="editPassword-oldPassword"
          />
        </v-col>
        <v-col>
          <VPassword
            v-model="user.password"
            :label="$t('forms.labels.newPassword')"
            :value="user.newPassword"
            :passwordConfirm="true"
            data-cy="editPassword-newPassword"
          />
        </v-col>
      </v-row>
      <v-row
        align="center"
        justify="end"
        class="mr-1"
      >
        <v-btn
          :disabled="!valid"
          type="submit"
          color="secondary"
          @click.prevent="updatePassword"
        >
          {{ $t('forms.btn.save') }}
        </v-btn>
      </v-row>
    </form>
  </ValidationObserver>
</template>

<script>
import { ValidationObserver } from 'vee-validate';
import VPassword from '@/components/shared/widgets/forms/VuetifyInputs/VPassword.vue';

export default {
    components: {
        ValidationObserver,
        VPassword,
    },
    data() {
        return {
            user: {
                oldPassword: '',
                password: '',
            },
        };
    },
    methods: {
        updatePassword() {
            this.$rq.postChangePassword(this.user).then(() => {
                this.$toasted.global.toast_success({
                    message: this.$t('msg.passwordChanged'),
                });
            });
        },
    },
};
</script>
